<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TVRGXi/tc-custom/9781476707716.jpg?1730491660683" alt="This image is the cover for the book Cavewomen Don't Get Fat"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cavewomen Don't Get Fat
      </h1>
      <p class="bookDescription body article font2">
        <b>From “a woman who is about to become as famous in the diet and fitness industries as Martha Stewart is in the world of home decoration” (Liz Jones, <i>The Daily Mail</i>), this back-to-basics approach helps you keep a protein-rich, hormone-balancing, and detoxifying diet to build muscle, catalyze fat loss, and feel gorgeous fast.<b></b></b><br/><br/>Weight loss may seem like a modern idea, but studies show that the solution is ancient: a natural diet of lean protein, vegetables, fruit, seeds, and nuts—and no processed starches—leads to a strong, healthy body that works well and looks great. Millions of years of evolutionary history can’t be wrong, and Esther Blum, a holistic nutritionist for nearly two decades, has helped her clients get gorgeous and strong by reinstating the simple, high-protein, low-carb diet that our bodies naturally crave.<br/><br/>Esther believes that the greatest gift you can give yourself is a lean, gorgeous body—for life. Through a potent combination of hormonal balance, a detoxified system, and muscle mass, anyone can achieve great results by following some simple no-nonsense tips. Esther breaks her diet down into three easy and sustainable phases: first, a two-week detox, followed by a second phase of hormone balance and fat loss, and then finally, a maintenance phase, which keeps you within 3 to 5 percent of your body fat ideal.<br/><br/>Smart, sassy, and sensible, <i>Cavewomen Don’t Get Fat</i> will help women everywhere feel and stay gorgeous from the inside out.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Esther Blum
      </h2>
      
      <p class="authorDescription body article">Esther Blum&#160;is a registered dietitian, holistic nutritionist, and author of&#160;<I>Cavewomen Don&#8217;t Get Fat</I>;&#160;<I>Eat, Drink, and Be Gorgeous: A Nutritionist&#8217;s Guide to Living Well While Living It Up</I>;&#160;<I>Secrets of Gorgeous</I>;&#160;and&#160;<I>The Eat, Drink, and Be Gorgeous Project.&#160;</I>She has extensive media experience, appearing on nationally syndicated talk shows and news programs, lectures widely to groups across the country, and maintains a private practice in Connecticut.<B></B>Visit&#160;LivingGorgeous.com&#160;for tips, free resources, and more.<BR><BR>For complementary bonus resources to further your Paleo Chic education, please visit LivingGorgeous.com/gifts.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f86667b